import { render, staticRenderFns } from "./VerDetalleRecepcionActividadModal.vue?vue&type=template&id=54baa3f1&"
import script from "./VerDetalleRecepcionActividadModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleRecepcionActividadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54baa3f1', component.options)
    } else {
      api.reload('54baa3f1', component.options)
    }
    module.hot.accept("./VerDetalleRecepcionActividadModal.vue?vue&type=template&id=54baa3f1&", function () {
      api.rerender('54baa3f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Recepcion/VerDetalleRecepcionActividadModal.vue"
export default component.exports